import React, { useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import Education from './components/Education/Education';
import CV from './components/CV/CV';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  useEffect(() => {
    // Keep domain constant at root https://sudipmajkoti.com.np (no /cv or /#/cv in address bar)
    const pathname = window.location.pathname;
    const hash = window.location.hash;
    if (pathname === '/cv' || pathname.endsWith('/cv') || hash.includes('cv')) {
      window.history.replaceState(null, '', '/');
      setTimeout(() => {
        const cvElem = document.getElementById('cv');
        if (cvElem) {
          cvElem.scrollIntoView({ behavior: 'smooth' });
        }
      }, 150);
    }
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Education />
      <CV />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
